import { axiosIns } from "../utils";

export const fetchCategories = async (params = {}) => {
  const query = {};
  if (params?.search) {
    query.search = params.search;
  }
  const response = await axiosIns.get("/categories/", { params: query });
  return response && response.data ? response.data : response;
};

export const fetchCategoryById = async (id) => {
  const response = await axiosIns.get(`/categories/${id}/`);
  return response && response.data ? response.data : response;
};

export const createCategoryApi = async (payload) => {
  const response = await axiosIns.post("/categories/", payload);
  return response && response.data ? response.data : response;
};

export const updateCategoryApi = async (id, payload) => {
  const response = await axiosIns.patch(`/categories/${id}/`, payload);
  return response && response.data ? response.data : response;
};

export const deleteCategoryApi = async (id) => {
  const response = await axiosIns.delete(`/categories/${id}/`);
  return response && response.data ? response.data : response;
};
